<template lang="pug">
  .banner.level(v-if="!accepted")
    div
      span A weboldalon sütiket (cookie-kat) használunk.&nbsp;
      a(href="http://forex.hu/adatkezeles" target="adatvedelmi_nyilatkozat") Adatkezelési tájékoztató
    button.button(@click="accept()") Elfogadom
</template>

<script>

  export default {
    data: () => ({
      accepted: false
    }),
    name: "CookieBanner",
    created() {
      this.accepted = !!localStorage.getItem("acceptCookies")
    },

    methods: {
      accept() {
        this.accepted = true;
        localStorage.setItem("acceptCookies", "1")
      }
    }
  }
</script>

<style lang='sass'>
.banner
  background: #181a26
  padding: .5rem 1rem
  color: #fff
  a
    color: #fff
    text-decoration: underline
    &:hover
      color: #d0d0d0
  .button
    font-weight: bold

</style>
